var customExperianInputsInit = (function () {
    'use strict';

    var keys = {
        ESC: 27,
        TAB: 9,
        RETURN: 13,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };

    var counter = 0;
    var insertedNodes = [];

    var mobileInput = document.querySelectorAll('input[name*="phone_with_country_codes"]');
    var addressInput = document.querySelectorAll('input[name*="address_search"]');
    var emailInput = document.querySelectorAll('input[name*="email_address"]');
    var countryInput = document.querySelectorAll('select[name*="country"]');
    var primaryStateInput = document.querySelectorAll('select[name="state"]')[0];
    var secondaryStateInput = document.querySelectorAll('select[name="co_borrower_state"]')[0];
    var streetNumber = 'input[name*="street_number"]';
    var streetName = 'input[name*="property_name"]';
    const requiredObject = { 'required': 'required', 'aria-required': true };
    const nonRequiredObject = { 'required': false, 'aria-required': false };

    var landlineType = "Landline";
    var validStatus = "Verified";

    function applyAddressLogic(index, el, prefix) {
        var chosenCountry = '';
        $(el).address({
            required: 'false',
            token: 'c9cc7eca-cf74-402c-aa11-4ff9a69dd109',
            searchDelayTimeout: 0,
            searchCountry: function () {
                var countryDropdown = $("[name*='country']", $(el).parents("[data-sf-role='separator']").first());
                var countryValue = countryDropdown.val();

                if (countryValue.toLowerCase().includes('australia')) {
                    return 'AUS';
                }
                else if (countryValue.toLowerCase().includes('new zealand')) {
                    return 'NZL';
                }
                return "AUS";
            },
            searchLayout: "APAC ANZ AUS Hardship",
            resultMappings: [
                {
                    selector: `input[name="${el.name}"]`,
                    format: '{{Building_Name}} {{Unit}} {{Street_Number}} {{Street_Name}} {{Street_Type}}, {{Locality}}, {{State_Code}} {{Postcode}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('property_name', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Building_Name}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('unit_number', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Unit}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('street_number', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Street_Number}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('street_name', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Street_Name}}'
                }, {
                    selector: `select[name="${getRealFieldNameInContext('street_type', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Street_Type}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('city', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Locality}}'
                }, {
                    selector: `select[name="${getRealFieldNameInContext('state', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{State_Code}}'
                }, {
                    selector: `input[name="${getRealFieldNameInContext('postcode', $(el).parents("[data-sf-role='separator']").first())}"]`,
                    format: '{{Postcode}}'
                }]
        });
    }

    function getRealFieldNameInContext(partialName, context) {
        return $(`[name*='${partialName}']`, context).attr("name");
    }

    function doKeypress(input, keys, event) {
        var parent = $(input).parent('.form-group');
        var selectedItem = $(input).parent('.form-group').find('.selected');
        switch (event.which || event.keyCode) {
            case keys.ESC:
                $(input).removeAttr("aria-activedescendant");
                $(input).attr('aria-expanded', false);
                $('.xpn-address-picklist-container').hide();
                //$('.xpn-address-picklist-item-override').trigger('click');
                $(input).val('').focus();
                $('#announce').empty();
                break;

            case keys.TAB:
                if (selectedItem) {
                    $('.selected', parent).trigger('click');
                }
                else {
                    $(input).removeAttr("aria-activedescendant");
                    $(input).attr('aria-expanded', false);
                    $('.xpn-address-picklist-container').hide();
                    $('#announce').empty();
                }

                break;

            case keys.UP:
                event.preventDefault();
                event.stopPropagation();

                $('.selected', parent).attr('aria-selected', true);
                $(input).attr("aria-activedescendant", $(selectedItem).attr('id'));
                if (selectedItem) {
                    $(input).val($('.selected', parent).text());
                }
                break;

            case keys.DOWN:
                event.preventDefault();
                event.stopPropagation();

                $('.selected').attr('aria-selected', true);
                $(input).attr("aria-activedescendant", $(selectedItem).attr('id'));
                if (selectedItem) {
                    $(input).val($('.selected', parent).text());
                }
                break;

            default:
                return;
        }
    }

    function observeAddressPickListItems(addressList) {
        const config = { attributes: false, childList: true, subtree: true };

        const callback = function (mutationsList, observer) {
            mutationsList.forEach(function (mutation) {
                if (!mutation.addedNodes) return;

                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    var node = mutation.addedNodes[i];
                    if ($(node).is(':not(.xpn-address-picklist-item-info)')) {
                        $(node).attr('tabindex', -1);
                        $(node).attr('role', 'option');
                        $(node).attr('aria-selected', false);
                        $(node).attr('id', 'item-' + Date.now() + ((Math.random() * 100000).toFixed()));
                    }
                };
            });
        };

        const observer = new MutationObserver(callback);

        observer.observe(addressList, config);
    }

    function doAccessibilityPreparation(event) {
        var addressList = document.getElementsByClassName('xpn-address-picklist');

        [...addressList].forEach(
            (element, index, array) => {
                let $element = $(element);
                $element.attr('id', 'addressList');
                $element.attr('role', 'listbox');
                //$(element).attr('tabindex', 0);

                observeAddressPickListItems(element);

                let elementChildren = $element.children("[xpn-moniker!='']");

                if (elementChildren.length) {
                    $(event.currentTarget).attr('aria-expanded', true);
                    $("#announce").text(+elementChildren.length + " suggestions found, " + "press Escape to manually enter address");
                } else {
                    $("#announce").text($(event.target).val() + ' typed, enter more information to narrow down your search');
                }
            }
        );
    }

    function initAddressInput() {
        $(addressInput).each((index, el) => {
            applyAddressLogic(index, el, "");
            $(el).removeAttr("aria-activedescendant");
            $(el).attr('role', 'combobox');
            $(el).attr('aria-owns', 'addressList');
            $(el).attr('aria-autocomplete', 'list');
            $(el).attr('aria-expanded', false);
            $(el).attr('autocomplete', 'off');

            //create announce element for screen readers
            var announce = $('<div class="sr-only" aria-live="assertive"></div>').attr('id', 'announce');
            $(addressInput).parent().prepend(announce);
        });

        $(addressInput).on("addressaftercreatepicklist", doAccessibilityPreparation);

        $(addressInput).on("keydown", function (event) {
            doKeypress(this, keys, event);
        });

        // Register callback on formatted address.
        $(addressInput).on('addressbeforemap', function (event, item) {
            if (item.address.Country.toLowerCase().includes('new zealand')) {
                item.address.State_Code = "";
            }

            if (item.override) {
                for (let prop in item.address) {
                    item.address[prop] = '';
                }
            }
        });

        //re-trigger validation on fields when address search completes
        $(addressInput).on('addressaftermap', function (event, item) {
            var allInputs = $(addressInput).closest('form').find('input:visible, textarea:visible, select:visible');
            var wrp = $(this).closest("div[data-sf-role='separator']");
            var streetNameInput = wrp.find(streetName);
            var streetInput = wrp.find(streetNumber);
            allInputs.toArray().forEach((i) => {
                //select needs val assigned before change kicks in
                var selectedVal = $(i).val();
                $(i).val(selectedVal).trigger('change');
            });
            if (streetNameInput.val() === '') {
                streetInput.attr(requiredObject);
                streetInput.prev('label').find('sup').html('<i class="fas fa-asterisk"></i>');
            }
            else {
                streetInput.attr(nonRequiredObject);
                streetInput.prev('label').find('sup').empty();
            }
        });
    }

    function initEmailInput() {
        var stateChaned = false;
        $(emailInput).each((index, el) => {
            $(el).email({
                token: 'c9cc7eca-cf74-402c-aa11-4ff9a69dd109',
                searchDelayTimeout: 0,
                searchTrigger: "blur",
                required: false
            });
        });
        $(emailInput).on("focus", function () {
            $(this).parent().find(".sr-only").empty();
            $(this).parent().find(".sr-only").attr({ "role": "", "aria-live": "" });
        });
        $(emailInput).on("change", function () {
            if ($(this).val()) {
                $(this).parent().find(".sr-only").attr({ "role": "alert", "aria-live": "assertive" });
                $(this)[0].setCustomValidity("validating");
            }
            else {
                $(this)[0].setCustomValidity("");
                $(this).parent().find(".sr-only").empty();
                $(this).parent().find(".sr-only").attr({ "role": "", "aria-live": "" });
            }
        });

        $('button[data-sf-btn-role="next"]').click(function () {
            var emailInputField = $(this).closest('div[data-sf-role="separator"]').find(emailInput);
            if (emailInputField.length) {
                var stateOfInputField = emailInputField.data().experianEmail._fsm._currentState;
                if (stateOfInputField == "loading" || stateOfInputField == "unverified") {
                    stateChaned = true;
                    $(emailInputField).parent().find(".sr-only").text("Please wait, validating email.");
                }
                else {
                    stateChaned = false;
                    $(emailInputField).parent().find(".sr-only").empty();
                }
            }
        });
        function observeEmailInvalidation(inputNode) {
            const config = { attributes: true, childList: false, subtree: false };

            const callback = function (mutationsList, observer) {
                var currentState = $(inputNode).data().experianEmail._fsm._currentState;
                var isVerified = currentState == "verified";
                if (isVerified) {
                    $(inputNode)[0].setCustomValidity("");
                    if (stateChaned) {
                        $(inputNode).parent().find(".sr-only").text("Email is verified. You can proceed.");
                    }
                }
                else if (currentState == "invalid") {
                    $(inputNode)[0].setCustomValidity("invalid");
                }
                else if (currentState == "loading") {
                    $(inputNode)[0].setCustomValidity("validating");
                }
                setTimeout(function () {
                    if (($(inputNode).val() && !isVerified) && $(inputNode).parent().find(".xpn-email-errormsg").css("display") != "none") {
                        $(inputNode).parent().find(".sr-only").text($(inputNode).parent().find(".xpn-email-workspace").text());
                    }
                }, 300);
            };

            const observer = new MutationObserver(callback);

            observer.observe(inputNode, config);
        }

        for (var i = 0; i < emailInput.length; i++) {
            observeEmailInvalidation(emailInput[i]);
        }
    }

    function initEdqMobile($mobileInput) {
        $mobileInput.mobileValidate({
            token: 'c9cc7eca-cf74-402c-aa11-4ff9a69dd109',
            required: false,
            searchDelayTimeout: 0,
            searchTrigger: "blur",
            acceptedResults: ["Verified", "No coverage"]
        });

        $mobileInput.on("change", function () {
            $mobileInput.removeClass("valid-phone-type");
            $mobileInput.next(".xpn-mobile-workspace").attr({ "role": "", "aria-live": "" });
            $mobileInput.next(".xpn-mobile-workspace").empty();
        });

        $mobileInput.on("mobilevalidatebeforevalidate", function (e, query) {
            $mobileInput.removeClass("valid-phone-type");
            var nextBtn = $('button[data-sf-btn-role="next"]');
            // disable
            $(nextBtn).prop('disabled', true);

            $mobileInput.next(".xpn-mobile-workspace").attr({ "role": "status", "aria-live": "assertive" });

            var prefixAttr = $(this).prev().find(".iti__selected-flag").attr("title");
            var stringParts = prefixAttr.split(": ");
            var prefix = stringParts[1];

            if (!query.number.startsWith(prefix.substr(1)) && !query.number.startsWith(prefix)) {
                if (query.number.startsWith("0")) {
                    // Strips out zero 
                    query.number = query.number.substr(1);
                    query.number = prefix + query.number;
                } else {
                    query.number = prefix + query.number;
                }
            }
        });

        $mobileInput.on("mobilevalidateaftervalidate", function (e, result) {
            var nextBtn = $('button[data-sf-btn-role="next"]');
            if (!(landlineType.includes(result.phoneType) || validStatus.includes(result.confidence))) {
                $(nextBtn).prop('disabled', true);
                $mobileInput.removeClass("valid-phone-type");
            }
            else {
                $(nextBtn).prop('disabled', false);
                $mobileInput.addClass("valid-phone-type");
                $mobileInput.next(".xpn-mobile-workspace").attr({ "role": "", "aria-live": "" });
            }
        });
    }

    function initMobileInput() {
        $(mobileInput).each((index, el) => {
            var $mobileInput = $(el);

            $mobileInput.intlTelInput({
                preferredCountries: ['au', 'nz']
            });

            initEdqMobile($mobileInput);
            
            $("[role=combobox]", $mobileInput.parent()).each(function () {
                var attrVal = $(this).attr('aria-describedby');
                if (attrVal == null || attrVal == 'undefined' | attrVal.length == 0) {
                    $(this).attr('aria-describedby', 'dropdown-instructions');
                } else {
                    $(this).attr('aria-describedby', attrVal + ' dropdown-instructions');
                }
            });

            $mobileInput.on("countrychange", function (e, countryData) {
                $mobileInput.val('');
            });

            $mobileInput.intlTelInput("setCountry", "au");

            $mobileInput.intlTelInput("setNumber", $mobileInput.val());

            if ($mobileInput.val() !== '') {
                $mobileInput.mobile("validate");
            }

            $mobileInput.on('input', function (e) {
                if ($(this).val() === '') {
                    var nextBtn = $('button[data-sf-btn-role="next"]');
                    $(nextBtn).prop('disabled', false);
                }
            });
        });
    }

    if (mobileInput.length) {
        initMobileInput();
    }
    if (addressInput.length) {
        initAddressInput();
    }
    if (emailInput.length) {
        initEmailInput();
    }
    if (countryInput.length) {
        [...countryInput].forEach((cInput) => {
            cInput.addEventListener('change', function (event) {
                var lastSelectedCountry = this.value;
                var wrp = $(this).closest("div[data-sf-role='separator']");
                var streetInput = wrp.find(streetNumber);
                wrp.find('input[data-sf-role="text-field-input"], select[data-sf-role="dropdown-list-field-select"]').val("");
                $('.xpn-address').removeClass('xpn-address-verified');
                this.value = lastSelectedCountry;
                streetInput.attr(requiredObject);
                streetInput.prev('label').find('sup').html('<i class="fas fa-asterisk"></i>');
            });
        });
    }
})();


